module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper willmustlist pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": _vm.goTop
    }
  }, [_vm._v("戻る")])])]), _c('div', {
    staticClass: "treatment__container"
  }, [_c('div', {
    staticClass: "row bg04"
  }, [_vm._m(0), _c('div', {
    staticClass: "treatment__tabs"
  }, [_c('ul', {
    staticClass: "treatment__tabs__wrap"
  }, [_c('li', {
    staticClass: "treatment__tabs__item -salary",
    on: {
      "click": function($event) {
        _vm.goTreatmentSalaryList()
      }
    }
  }, [_c('span', [_vm._v("給与関連")])]), _vm._m(1), _c('li', {
    staticClass: "treatment__tabs__item -rule",
    on: {
      "click": function($event) {
        _vm.goTreatmentRuleList()
      }
    }
  }, [_c('span', [_vm._v("制度関連")])])])])]), _c('div', {
    staticClass: "treatment__tab-body"
  }, [_c('div', {
    staticClass: "treatment__tab-contents"
  }, [_vm._m(2), _vm._m(3), _c('h2', {
    staticClass: "treatment__tab-heading"
  }, [_vm._v("有給")]), _c('div', {
    staticClass: "treatment__tab-buttons"
  }, [_c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('paid_holidays')
      }
    }
  }, [_vm._v("有給休暇")]), _vm._m(4)]), _vm._m(5), _c('h2', {
    staticClass: "treatment__tab-heading"
  }, [_vm._v("出産・育児")]), _c('div', {
    staticClass: "treatment__tab-buttons"
  }, [_c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('maternity_leave')
      }
    }
  }, [_vm._v("産前産後休暇")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('childcare_leave')
      }
    }
  }, [_vm._v("育児休業")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('sick_childcare_leave')
      }
    }
  }, [_vm._v("看護休暇")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('short_time_work_for_childcare')
      }
    }
  }, [_vm._v("育児短時間勤務")])]), _vm._m(6), _c('h2', {
    staticClass: "treatment__tab-heading"
  }, [_vm._v("その他休暇")]), _c('div', {
    staticClass: "treatment__tab-buttons"
  }, [_c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('nursing_care_leave')
      }
    }
  }, [_vm._v("介護休業")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('short_time_work_for_nursing_care')
      }
    }
  }, [_vm._v("介護短時間勤務")])]), _c('div', {
    staticClass: "treatment__tab-buttons-single"
  }, [_c('button', {
    staticClass: "btn01_treatment-single",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('menstrual_leave')
      }
    }
  }, [_vm._v("生理休暇")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__heading"
  }, [_c('h2', {
    staticClass: "treatment__heading__title"
  }, [_c('span', {
    staticClass: "treatment__heading__img"
  }, [_c('div', {
    staticClass: "heading_01-treatment"
  }, [_vm._v("待遇・制度の一覧だニャン！")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "treatment__tabs__item -leave -active"
  }, [_c('span', [_vm._v("休暇関連")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__tab-notice"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_cat_02.png"),
      "alt": "",
      "width": "48px",
      "height": "42px"
    }
  }), _c('h2', {
    staticClass: "treatment__tab-notice-baloon"
  }, [_vm._v("休暇はみんなの協力が必要なので早めに報告してくれニャン！")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__icons"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_calender_darkbrown.png"),
      "alt": "",
      "width": "16px",
      "height": "16px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__tab-comment"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_cat_03.png"),
      "alt": "",
      "width": "32px",
      "height": "42px"
    }
  }), _c('span', [_vm._v("プライベートが充実だニャン")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__icons"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_baby.png"),
      "alt": "",
      "width": "16px",
      "height": "16px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__icons"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_bed.png"),
      "alt": "",
      "width": "16px",
      "height": "16px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48451a8c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/treatment-leave-list.pug
// module id = 1407
// module chunks = 1